import type { FC } from 'react';

interface Props {
  text: string;
  source?: string;
  primary?: boolean;
}

const BaseCallout: FC<Props> = ({ text, source, primary }) => (
  <div
    className={`m-8 border-l-2 px-6 ${
      primary ? 'border-leland-primary' : ' border-leland-gray-dark'
    }`}
  >
    <p className="whitespace-pre-wrap text-xl italic text-leland-gray-dark">
      {text}
    </p>
    {source ? (
      <p className="mt-2 text-sm text-leland-gray-dark">{source}</p>
    ) : null}
  </div>
);

export default BaseCallout;

export const BaseCalloutHtml: FC<Props> = ({ text, source }) => (
  <div>
    <p>{text}</p>
    {source ? <p>{source}</p> : null}
  </div>
);
